export default "__VITE_ASSET__CCHZDcaZ__"